import { render } from "./WatchUse.vue?vue&type=template&id=0fd70e39&scoped=true"
import script from "./WatchUse.vue?vue&type=script&lang=js"
export * from "./WatchUse.vue?vue&type=script&lang=js"

import "./WatchUse.vue?vue&type=style&index=0&id=0fd70e39&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd70e39"]])

export default __exports__